import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import Product from '@common/models/Product';
import { RootState } from '@common/store';
import { addProductToCart } from '@common/store/cart/slice';
import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
import StarRating from '@components/Rating/StarRating';
import Share from '@components/Share';
import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

export interface designProps {
  productCardWidth?: string;
  innerProductCardWidth?: string;
  toasts: ToastWithKeyType[];
}

export interface ProductProps {
  addToast: typeof addToast;
  removeToast: typeof removeToast;
  type?: string;
  isZoomEnabled?: boolean;
  quickView?: boolean;
  product: Product;
  cartProductQuantity: number;
  addProductToCart: typeof addProductToCart;
  storeType: string;
  toasts: ToastWithKeyType[];
  design?: designProps;
  onClose?: () => void;
  review: number;
  wishListFeature: boolean;
  finalProduct: Product;
  hocArgs: unknown;
  productVideoFeature: boolean;
  reviewsCount: number;
}

const ProductComponent: React.FunctionComponent<ProductProps> = ({
  isZoomEnabled = false,
  quickView,
  product,
  cartProductQuantity,
  addToast,
  addProductToCart,
  storeType,

  review,
  wishListFeature,
  productVideoFeature,
  reviewsCount,
}) => {
  return (
    <ProductAddToCartHOC
      variantSetToMinQuantity={true}
      disableSuccessToasts={() => false}
      product={product}
      render={(hocArgs) => {
        const { finalProduct } = hocArgs;
        const rating = parseInt(finalProduct.averageRating);
        return (
          <div className="w-full">
            <div className={classnames(`bg-white rounded-md `)}>
              <div className="flex flex-wrap md:flex-no-wrap">
                <div className={classnames('w-full md:w-622')}>
                  <Gallery
                    isZoomEnabled={isZoomEnabled}
                    images={finalProduct.images.length ? finalProduct.images : product.images}
                    quickView={quickView}
                    inStock={finalProduct.inStock}
                    imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                      finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
                    }`}
                    productVideoUrl={finalProduct.productVideoUrl}
                    productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
                  />
                </div>
                <div className={`flex flex-col md:pl-24 mt-46 md:mt-0`}>
                  <div className={classnames({ 'md:max-w-412 md:mr-100': quickView })}>
                    <h1
                      className={classnames('flex text-30 md:text-40 font-bold text-theme content-start')}
                      font-customisation="section-heading"
                      color-customisation="page-heading"
                      id="product-title"
                    >
                      {finalProduct.title}
                    </h1>
                    <div className="flex mt-20 md:mt-16" font-customisation="para-text">
                      {rating > 0 ? (
                        <div className=" flex pr-6 text-gray text-16 font-medium md:pl-6 border border-opacity-60 border-theme border-l-0 border-r-1 border-t-0 border-b-0">
                          <StarRating
                            rating={rating ? rating : 0}
                            halfRating={rating ? (Number.isInteger(rating) ? 0 : 1) : 0}
                            total={5}
                            isInteractive={false}
                            className="mr-4"
                          />
                          {rating ? Math.round(rating * 10) / 10 : 0}
                        </div>
                      ) : null}
                      {review > 0 ? (
                        <div
                          onClick={() => {
                            if (!quickView) {
                              const elmntToView = document.getElementById('Review');
                              elmntToView.scrollIntoView();
                            }
                          }}
                          className=" cursor-pointer text-gray underline text-16 pl-6 font-medium"
                        >
                          {reviewsCount} Reviews
                        </div>
                      ) : null}
                    </div>
                    <ProductAddToCart
                      product={product}
                      addToast={addToast}
                      cartProductQuantity={cartProductQuantity}
                      addProductToCart={addProductToCart}
                      hocArgs={hocArgs}
                      storeType={storeType}
                      quickView={quickView}
                      wishListFeature={wishListFeature}
                    />
                  </div>
                </div>
              </div>
              {!quickView && (
                <>
                  {finalProduct.description && !quickView ? (
                    <div className="mt-20 mb-20 md:mt-44 md:mb-0">
                      <div
                        className="text-neutral text-21 md:text-20 leading-22 md:leading-34 mb-30 md:mb-18 font-semibold"
                        font-customisation="section-heading"
                        color-customisation="page-heading"
                      >
                        Product Description
                      </div>
                      <div className="description px-0">
                        <Editor
                          name="productLongDescription"
                          value={finalProduct.description}
                          readonly={true}
                          isDefaultFont={true}
                        />
                      </div>
                    </div>
                  ) : null}
                  <div className="w-full flex justify-center">
                    <div className="bg-bgShare rounded-10 p-24 w-340 min-w-340 md:min-w-full md:w-full items-center md:mx-auto mt-20 md:mt-44">
                      <Share className="w-full" product={product} />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      }}
    />
  );
};

export default connect(
  ({ toasts }: RootState) => ({
    toasts,
  }),
  {
    removeToast,
  },
)(ProductComponent);
